// extracted by mini-css-extract-plugin
export default {"media":"Ob","mediaCurrent":"Pb","mediaLeft":"Qb","videoWrapper":"Rb","text":"Sb","textCurrent":"Tb","icon":"Ub","blinking":"Vb"};